var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.authorized && _vm.loggedInPerson)?_c('router-view',{attrs:{"logged-in-person":_vm.loggedInPerson}}):_c('div',{staticClass:"d-flex justify-center align-center ma-16"},[_c('v-progress-circular',{attrs:{"size":100,"color":"primary","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }